module.exports = __webpack_public_path__ + "static/media/care_device_pin2.a0d04668.svg";